import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import {
  addContact,
  removeContact
} from 'src/app/core/services/contacts/contacts.actions';
import {
  subscribeTo,
  unsubscribeFrom
} from 'src/app/core/services/groups/groups.actions';
import {
  getOrgMembers,
  loadOrganization,
  loadOrgChapters,
  loadOrgJobs,
  loadOrgReviews,
  createJob,
  deleteJob,
  addReview,
  inviteToProject,
  editJob
} from 'src/app/core/services/organization/organization.actions';
import {
  State as OrganizationState,
  selectMembers,
  selectOrganization,
  selectChapters,
  selectJobs,
  selectReviews
} from 'src/app/core/services/organization/organization.reducer';
import { Job } from 'src/app/core/services/organization/organization.model';
import {
  orgSubscribeTo,
  orgUnSubscribeFrom
} from 'src/app/core/services/organizations/organizations.actions';
import { IMessage } from 'src/app/shared/components/message/message.component';
import {
  addPost,
  loadPostsByUserId
} from 'src/app/shared/ui/post/data/store/actions';
import { selectPosts } from 'src/app/shared/ui/post/data/store/selector';
import { PostsFacade } from 'src/app/modules/posts/store';

@Injectable()
export class OrganizationFacade {
  readonly organization$ = this.store.pipe(select(selectOrganization()));
  readonly members$ = this.store.pipe(select(selectMembers()));
  readonly groups$ = this.store.pipe(select(selectChapters()));
  readonly jobs$ = this.store.pipe(select(selectJobs()));
  readonly reviews$ = this.store.pipe(select(selectReviews()));
  readonly posts$ = this.store.select(selectPosts({}));

  constructor(
    private readonly store: Store<OrganizationState>,
    private readonly postFacade: PostsFacade
  ) {}

  loadPosts(id: string) {
    // TODO: refactor
    // remove Number cast
    this.store.dispatch(loadPostsByUserId({ id }));
  }

  loadOrganization(id: string) {
    this.store.dispatch(loadOrganization({ id }));
  }

  loadMembers(id: string, page: number, searchTerm: string) {
    this.store.dispatch(getOrgMembers({ id, page, searchTerm }));
  }

  loadGroups(id: string, page: number, searchTerm: string) {
    this.store.dispatch(loadOrgChapters({ id, page, searchTerm }));
  }

  loadJobs(id: string, page: number = 1) {
    this.store.dispatch(loadOrgJobs({ id, page }));
  }

  loadReviews(id: string) {
    this.store.dispatch(loadOrgReviews({ id }));
  }

  createJob(job: Job) {
    this.store.dispatch(createJob({ job }));
  }

  editJob(job: Job) {
    this.store.dispatch(editJob({ job }));
  }

  deleteJob(job: Job) {
    this.store.dispatch(deleteJob({ job }));
  }

  inviteToProject(email: string, orgId: string) {
    this.store.dispatch(inviteToProject({ email, orgId }));
  }

  subscribe(id: number) {
    this.store.dispatch(orgSubscribeTo({ id }));
  }

  unsubscribe(id: number) {
    this.store.dispatch(orgUnSubscribeFrom({ id }));
  }

  connect(id: number) {
    this.store.dispatch(addContact({ id }));
  }

  disconnect(id: number) {
    this.store.dispatch(removeContact({ id }));
  }

  join(id: number) {
    this.store.dispatch(subscribeTo({ id }));
  }

  leave(id: number) {
    this.store.dispatch(unsubscribeFrom({ id }));
  }

  publishReview(review: {
    obj_id: number;
    text: string;
    is_anonymous: boolean;
  }) {
    this.store.dispatch(addReview(review));
  }

  publishPost(message: IMessage) {
    this.postFacade.addPost(message);
  }
}
